import { ZoomMtg } from "@zoom/meetingsdk";
import axios from "axios";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { useAuth } from "../context/AuthContext";

ZoomMtg.preLoadWasm();

export default function ZoomMeeting({
  sessionID,
  meetingNumber,
  passWord = "",
  userName = "Guest",
  userEmail = "",
  meetingType = 1,
  leaveUrl = `${window.location.origin}/end-meeting-message`,
}) {
  const { i18n } = useTranslation();
  const { user } = useAuth();
  const joinTimeRef = useRef(null);
  const mountedRef = useRef(true);

  // Fetch signature and start the meeting
  const getSignature = async () => {
    try {
      ZoomMtg.prepareWebSDK();

      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/generate-signature/${sessionID}`, {
        headers: {
          lang: i18n.language,
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          type: meetingType,
        },
      });

      const signature = res.data.data.signature;
      if (mountedRef.current) startMeeting(signature);
    } catch (error) {
      console.error("Error getting signature:", error);
    }
  };

  const startMeeting = (signature) => {
    const root = document.getElementById("zmmtg-root");
    if (root) root.style.display = "block";

    ZoomMtg.init({
      leaveUrl,
      patchJsMedia: true,
      leaveOnPageUnload: false,
      success: () => {
        ZoomMtg.join({
          signature,
          meetingNumber,
          passWord,
          userName,
          userEmail,
          success: () => {
            console.log("✅ Joined meeting");
            joinTimeRef.current = Date.now();

            setTimeout(() => {
              // 1️⃣ Adjust zoom-workplace-logo margin
              const logo = document.querySelector(".zoom-workplace-logo");
              if (logo && i18n.language === "ar") {
                logo.style.marginLeft = "-15px";
              }

              // 2️⃣ Show button only on mobile (screen width <= 768px)
              if (window.innerWidth <= 768) {
                const infoContainer = document.querySelector(".meeting-info-container");

                if (infoContainer) {
                  infoContainer.innerHTML = "";
                  infoContainer.style.marginLeft = i18n.language == "en" ? "0" : "";
                  const leaveBtn = document.createElement("button");

                  // Get language from i18next
                  leaveBtn.textContent = i18n.language == "ar" ? "مغادرة" : "Leave Meeting";

                  leaveBtn.style.padding = "5px 9px";
                  leaveBtn.style.backgroundColor = "#EB2A2A";
                  leaveBtn.style.color = "#fff";
                  leaveBtn.style.border = "none";
                  leaveBtn.style.borderRadius = "4px";
                  leaveBtn.style.cursor = "pointer";
                  leaveBtn.style.fontSize = "12px";

                  leaveBtn.addEventListener("click", () => {
                    ZoomMtg.leaveMeeting({
                      success: () => {
                        console.log("✅ Left meeting via custom button");
                        window.location.href = leaveUrl;
                      },
                      error: (err) => console.error("❌ Leave error:", err),
                    });
                  });

                  infoContainer.appendChild(leaveBtn);
                }
              }
            }, 1000);
          },
          error: (error) => console.error("❌ Join error:", error),
        });
      },
      error: (error) => console.error("❌ Init error:", error),
    });
  };

  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    const pad = (num) => String(num).padStart(2, "0");

    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate()) +
      " " +
      pad(date.getHours()) +
      ":" +
      pad(date.getMinutes()) +
      ":" +
      pad(date.getSeconds())
    );
  };
  const handleDuration = async () => {
    const leaveTime = Date.now();
    if (joinTimeRef.current) {
      const totalSeconds = Math.floor((leaveTime - joinTimeRef.current) / 1000);

      const from = formatDateTime(joinTimeRef.current);
      const to = formatDateTime(leaveTime);
      // Save raw seconds
      localStorage.setItem("duration", totalSeconds.toString());
      localStorage.setItem("sessionID", sessionID);
      localStorage.setItem("meetingType", meetingType);
      localStorage.setItem("from", from);
      localStorage.setItem("to", to);
    }
  };

  useEffect(() => {
    mountedRef.current = true;
    getSignature();

    // Listen for user join/leave
    ZoomMtg.inMeetingServiceListener("onUserJoin", () => {
      joinTimeRef.current = Date.now();
    });

    ZoomMtg.inMeetingServiceListener("onUserLeave", () => {
      handleDuration();
    });

    return () => {
      mountedRef.current = false;

      try {
        ZoomMtg.leaveMeeting({
          success: () => console.log("Left meeting successfully"),
          error: (err) => console.warn("Zoom leaveMeeting error:", err),
        });
      } catch (err) {
        console.warn("Zoom leaveMeeting failed:", err);
      }

      // Optional: reload page to force redirect or cleanup SDK
      window.location.reload();
    };
  }, []);

  return <div id="zmmtg-root" />;
}
